import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/Layout";
import { Input } from "@/components/ui/input";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Please enter your email and password.");
    setBusy(true);
    try {
      await api.post("/admin/login", { email, password });
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0D3B2B] p-4">
      <form onSubmit={submit} className="ks-rise w-full max-w-sm space-y-4 rounded-3xl bg-white p-8" data-testid="admin-login-form">
        <Logo />
        <h1 className="font-display text-2xl font-extrabold text-[#0D3B2B]">Admin login</h1>
        <p className="text-sm text-[#4A6358]">For the Kindsaver team only.</p>
        <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl" data-testid="admin-email-input" />
        <Input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl" data-testid="admin-password-input" />
        <button disabled={busy} className="h-12 w-full rounded-2xl bg-[#0D3B2B] font-bold text-white disabled:opacity-60" data-testid="admin-login-submit-btn">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
